//#region src/item_taxation_status.ts
var ItemTaxationStatus = /* @__PURE__ */ function(ItemTaxationStatus) {
	ItemTaxationStatus[ItemTaxationStatus["Taxable"] = 0] = "Taxable";
	ItemTaxationStatus[ItemTaxationStatus["TaxIncluded"] = 1] = "TaxIncluded";
	ItemTaxationStatus[ItemTaxationStatus["NotTaxable"] = 2] = "NotTaxable";
	ItemTaxationStatus[ItemTaxationStatus["Inherit"] = 3] = "Inherit";
	return ItemTaxationStatus;
}(ItemTaxationStatus || {});
//#endregion
export { ItemTaxationStatus };

//# sourceMappingURL=item_taxation_status.js.map